// ../base/src/emitter/RPCMethod.ts
var RPCMethod = class {
  account;
  crossNetworkChain;
  retryLimit = 2;
  detectTimeout = 1500;
  subTimeout = 1e3;
  subInterval = 100;
  detectAndSetProvider = (config) => {
    const p = this.detectProvider(config);
    p.then((provider) => this.provider = provider).catch((err) => console.warn(err, Date.now()));
    return p;
  };
  subProvider = () => {
    if (this.provider)
      return Promise.resolve(this.provider);
    return this.detectAndSetProvider({
      timeout: this.subTimeout,
      interval: this.subInterval
    });
  };
  setAccounts = (accounts) => {
    this.account = accounts?.[0];
  };
  getProvider = () => this.provider;
};
var RPCMethod_default = RPCMethod;
export {
  RPCMethod_default as default
};
